export default {
    // 中
    zhCN: {
        fill_in_at_least_one_query_condition: '至少填写一个查询条件',
        full_query: '全量查询',
        query_time: '查询时间',
        organization_code: '组织CODE',
        organization_name: '组织名称',
        country: '国家',
        number_of_cases: '案例总数',
        waiting_for_reply_cases: '未答复案例数量',
        percentage_of_No_Responses: '未答复数量百分比',
        replied_cases: '已答复案例数量',
        percentage_of_replied_cases: '已答复案例百分比',
        closed_cases: '已结案案例数量',
        percentage_closed_cases: '已结案数量百分比',
    },
    // 英
    enUS: {
        fill_in_at_least_one_query_condition: 'Fill in at least one query condition',
        full_query: 'Full query',
        query_time: 'Query time',
        organization_code: 'Organization code',
        organization_name: 'Organization name',
        country: 'Country',
        number_of_cases: 'Number of cases',
        waiting_for_reply_cases: 'Waiting for reply cases',
        percentage_of_No_Responses: 'Percentage of No Responses',
        replied_cases: 'Replied cases',
        percentage_of_replied_cases: 'Percentage of replied cases',
        closed_cases: 'Closed cases',
        percentage_closed_cases: 'Closed cases(%)',
    },
    // 德
    deDE: {
        fill_in_at_least_one_query_condition: 'Füllen Sie mindestens eine Abfragebedingung aus',
        full_query: 'Vollständige Abfrage',
        query_time: 'Abfragezeit',
        organization_code: 'Organisationscode',
        organization_name: 'Organisationsname',
        country: 'Land',
        number_of_cases: 'Gesamtzahl der Fälle',
        waiting_for_reply_cases: 'Fälle, die auf Antwort warten',
        percentage_of_No_Responses: 'Prozentsatz der fehlenden Antworten',
        replied_cases: 'Beantwortete Fälle',
        percentage_of_replied_cases: 'Prozentsatz der beanstandeten Fälle',
        closed_cases: 'Geschlossene Fälle',
        percentage_closed_cases: 'Geschlossene Fälle (%)',
    },
    // 法
    frFR: {
        fill_in_at_least_one_query_condition: 'Remplissez au moins une condition de demande',
        full_query: 'Requête complète',
        query_time: 'Temps de requête',
        organization_code: 'Code d\'organisation',
        organization_name: 'Nom d\'organisation',
        country: 'Pays',
        number_of_cases: 'Nombre total de cas',
        waiting_for_reply_cases: 'Cas en attente de réponse',
        percentage_of_No_Responses: 'Pourcentage du nombre de non - réponses',
        replied_cases: 'Cas auxquels on a répondu',
        percentage_of_replied_cases: 'Pourcentage de cas répondus',
        closed_cases: 'Cas fermés',
        percentage_closed_cases: 'Cas fermés(%)',
    },
    // 意大利
    itIT: {
        fill_in_at_least_one_query_condition: 'Compilare almeno una condizione di query',
        full_query: 'Query Completa',
        query_time: 'Tempo di Query',
        organization_code: 'Codice Organizzazione',
        organization_name: 'Nome Organizzazione',
        country: 'Paese',
        number_of_cases: 'Numero totale di casi',
        waiting_for_reply_cases: 'Numero di Casi in Attesa di Risposta',
        percentage_of_No_Responses: 'Percentuale di nessuna risposta',
        replied_cases: 'Numero di Casi ai Quali è Stata Fornita una Risposta',
        percentage_of_replied_cases: 'Percentuale di casi risolti',
        closed_cases: 'Numero di Casi Chiusi',
        percentage_closed_cases: 'Percentuale di Casi Chiusi',
    },
    // 荷兰
    nlNL: {
        fill_in_at_least_one_query_condition: 'Vul ten minste één query voorwaarde in',
        full_query: 'Volledige query',
        query_time: 'Query time',
        organization_code: 'Organisatie code',
        organization_name: 'Organisatie naam',
        country: 'Land',
        number_of_cases: 'Totaal aantal gevallen',
        waiting_for_reply_cases: 'Wachten op antwoord gevallen',
        percentage_of_No_Responses: 'Percentage van geen reacties',
        replied_cases: 'Beantwoorde gevallen',
        percentage_of_replied_cases: 'Percentage beantwoorde zaken',
        closed_cases: 'Gesloten gevallen',
        percentage_closed_cases: 'Gesloten gevallen(%)',
    },
    // 越南
    viVN: {
        fill_in_at_least_one_query_condition: 'Ít nhất điền một điều kiện tìm kiếm',
        full_query: 'Tra cứu toàn bộ',
        query_time: 'Thời gian truy vấn',
        organization_code: 'Mã tổ chức',
        organization_name: 'Tên tổ chức',
        country: 'Quốc gia',
        number_of_cases: 'Tổng số trường hợp',
        waiting_for_reply_cases: 'Số lượng trường hợp chờ phản hồi',
        percentage_of_No_Responses: 'Phần trăm trường hợp chưa phản hồi',
        replied_cases: 'Số lượng trường hợp đã phản hồi',
        percentage_of_replied_cases: 'Phần trăm trường hợp đã phản hồi',
        closed_cases: 'Số lượng trường hợp đã đóng',
        percentage_closed_cases: 'Phần trăm trường hợp đã đóng',
    },
    // 西班牙
    esES: {
        fill_in_at_least_one_query_condition: 'Al menos complete un criterio de búsqueda',
        full_query: 'Nombre de la organización',
        query_time: 'Tiempo de consulta',
        organization_code: 'Código de la organización',
        organization_name: 'Nombre de la organización',
        country: 'País',
        number_of_cases: 'Número total de casos',
        waiting_for_reply_cases: 'Cantidad de casos no respondidos',
        percentage_of_No_Responses: 'Porcentaje de casos no respondidos',
        replied_cases: 'Cantidad de casos respondidos',
        percentage_of_replied_cases: 'Porcentaje de casos respondidos',
        closed_cases: 'Cantidad de casos cerrados',
        percentage_closed_cases: 'Porcentaje de casos cerrados',
    },
    // 葡萄牙
    ptBR: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        full_query: 'Consulta completa',
        query_time: 'Tempo de consulta',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        waiting_for_reply_cases: 'Número de casos aguardando resposta',
        percentage_of_No_Responses: 'Porcentagem de casos sem resposta',
        replied_cases: 'Número de casos respondidos',
        percentage_of_replied_cases: 'Porcentagem de casos respondidos',
        closed_cases: 'Número de casos fechados',
        percentage_closed_cases: 'Porcentagem de casos fechados',
    },
    // 波兰
    plPL: {
        fill_in_at_least_one_query_condition: 'Wypełnij co najmniej jeden warunek zapytania',
        full_query: 'Pełne zapytanie',
        query_time: 'Data zapytania',
        organization_code: 'Kod organizacji',
        organization_name: 'Nazwa organizacji',
        country: 'Kraj',
        number_of_cases: 'Łączna liczba spraw',
        waiting_for_reply_cases: 'Liczba spraw oczekujących na odpowiedź',
        percentage_of_No_Responses: 'Liczba spraw oczekujących na odpowiedź (%)',
        replied_cases: 'Liczba udzielonych odpowiedzi',
        percentage_of_replied_cases: 'Liczba udzielonych odpowiedzi (%)',
        closed_cases: 'Sprawy zamknięte',
        percentage_closed_cases: 'Sprawy zamknięte (%)',
    },
    // 土耳其
    trTR: {
        fill_in_at_least_one_query_condition: 'En azından bir soru durumunu doldur',
        full_query: 'Tam soru',
        query_time: 'Sorgulama zamanı',
        organization_code: 'Organizasyon CODE',
        organization_name: 'Organizasyon adı',
        country: 'Ülke',
        number_of_cases: 'Toplam dosyalar',
        waiting_for_reply_cases: 'Dosyaların cevaplanması bekleniyor',
        percentage_of_No_Responses: 'Cevaplanmayı bekleyen dosyaların yüzdesi (%)',
        replied_cases: 'Cevaplanmış dosyalar',
        percentage_of_replied_cases: 'Cevaplanmış dosyaların yüzdesi %',
        closed_cases: 'Kapatılmış dosyalar',
        percentage_closed_cases: 'Kapatılmış dosyaların yüzdesi (%)',
    },
    // 捷克语
    csCZ: {
        fill_in_at_least_one_query_condition: 'Vyplňte alespoň jednu podmínku dotazu',
        full_query: 'Úplný dotaz',
        query_time: 'Čas dotazu',
        organization_code: 'Kód společnosti',
        organization_name: 'Název společnosti',
        country: 'Země',
        number_of_cases: 'Počet případů',
        waiting_for_reply_cases: 'Čeká na odpověď',
        percentage_of_No_Responses: 'Procento bez odpovědí',
        replied_cases: 'Odpovězené případy',
        percentage_of_replied_cases: 'Procento zodpovězených případů',
        closed_cases: 'Uzavřené případy',
        percentage_closed_cases: 'Uzavřené případy (%)',
    },
    // 匈牙利语
    huHU: {
        fill_in_at_least_one_query_condition: 'Töltsön ki legalább egy lekérdezési feltételt',
        full_query: 'Teljes lekérdezés',
        query_time: 'Lekérdezési idő',
        organization_code: 'Szervezet kódja',
        organization_name: 'Szervezet neve',
        country: 'Ország',
        number_of_cases: 'Esetek száma',
        waiting_for_reply_cases: 'Reakcióra váró esetek',
        percentage_of_No_Responses: 'Reakció nélküli százalék',
        replied_cases: 'Megválaszolt esetek',
        percentage_of_replied_cases: 'Megválaszolt esetek százaléka',
        closed_cases: 'Lezárt esetek',
        percentage_closed_cases: 'Lezárt esetek (%)',
    },
    // 俄罗斯语
    ruRU: {
        fill_in_at_least_one_query_condition: 'Заполните хотя бы одно условие запроса',
        full_query: 'Полный запрос',
        query_time: 'Время запроса',
        organization_code: 'Код организации',
        organization_name: 'Название организации',
        country: 'Страна',
        number_of_cases: 'Общее количество случаев',
        waiting_for_reply_cases: 'Количество ожидающих ответа случаев',
        percentage_of_No_Responses: 'Процент неотвеченных случаев',
        replied_cases: 'Количество ответов на случаи',
        percentage_of_replied_cases: 'Процент ответов на случаи',
        closed_cases: 'Количество закрытых случаев',
        percentage_closed_cases: 'Процент закрытых случаев',
    },
    // 沙特阿拉伯 (阿拉伯语)
    arSA: {
        fill_in_at_least_one_query_condition: 'يرجى إدخال شرط بحث واحد على الأقل',
        full_query: 'استعلام كامل',
        query_time: 'وقت الاستعلام',
        organization_code: 'رمز المنظمة',
        organization_name: 'اسم المنظمة',
        country: 'الدولة',
        number_of_cases: 'إجمالي عدد الحالات',
        waiting_for_reply_cases: 'عدد الحالات التي لم تُجب بعد',
        percentage_of_No_Responses: 'نسبة الحالات غير المجابة',
        replied_cases: 'عدد الحالات التي تم الرد عليها',
        percentage_of_replied_cases: 'نسبة الحالات التي تم الرد عليها',
        closed_cases: 'عدد الحالات المغلقة',
        percentage_closed_cases: 'نسبة الحالات المغلقة',
    },
    // 保加利亚语
    bgBG: {
        fill_in_at_least_one_query_condition: 'Моля, попълнете поне едно условие за търсене',
        full_query: 'Пълен заявкa',
        query_time: 'Време на заявката',
        organization_code: 'Код на организацията',
        organization_name: 'Име на организацията',
        country: 'Държава',
        number_of_cases: 'Общ брой случаи',
        waiting_for_reply_cases: 'Брой случаи без отговор',
        percentage_of_No_Responses: 'Процент случаи без отговор',
        replied_cases: 'Брой случаи с отговор',
        percentage_of_replied_cases: 'Процент случаи с отговор',
        closed_cases: 'Брой приключени случая',
        percentage_closed_cases: 'Процент приключени случаи',
    },
    // 丹麦语
    daDK: {
        fill_in_at_least_one_query_condition: 'Angiv mindst ét søgekriterie',
        full_query: 'Fuld forespørgsel',
        query_time: 'Forespørgselstidspunkt',
        organization_code: 'Organisationskode',
        organization_name: 'Organisationsnavn',
        country: 'Land',
        number_of_cases: 'Samlet antal sager',
        waiting_for_reply_cases: 'Antal ubesvarede sager',
        percentage_of_No_Responses: 'Procentdel ubesvarede sager',
        replied_cases: 'Antal besvarede sager',
        percentage_of_replied_cases: 'Procentdel besvarede sager',
        closed_cases: 'Antal lukkede sager',
        percentage_closed_cases: 'Procentdel lukkede sager',
    },
    // 芬兰语
    fiFI: {
        fill_in_at_least_one_query_condition: 'Anna vähintään yksi hakuehto',
        full_query: 'Koko tietojoukko',
        query_time: 'Hakuaika',
        organization_code: 'Organisaatiokoodi',
        organization_name: 'Organisaation nimi',
        country: 'Maa',
        number_of_cases: 'Tapauksien kokonaismäärä',
        waiting_for_reply_cases: 'Vastaamattomien tapausten määrä',
        percentage_of_No_Responses: 'Vastaamattomien tapausten prosenttiosuus',
        replied_cases: 'Vastattujen tapausten määrä',
        percentage_of_replied_cases: 'Vastattujen tapausten prosenttiosuus',
        closed_cases: 'Suljettujen tapausten määrä',
        percentage_closed_cases: 'Suljettujen tapausten prosenttiosuus',
    },
    // 繁体中文（台湾）
    zhTW: {
        fill_in_at_least_one_query_condition: '至少填寫一個查詢條件',
        full_query: '全量查詢',
        query_time: '查詢時間',
        organization_code: '組織CODE',
        organization_name: '組織名稱',
        country: '國家',
        number_of_cases: '案例總數',
        waiting_for_reply_cases: '未答覆案例數量',
        percentage_of_No_Responses: '未答覆數量百分比',
        replied_cases: '已答覆案例數量',
        percentage_of_replied_cases: '已答覆案例百分比',
        closed_cases: '已結案案例數量',
        percentage_closed_cases: '已結案數量百分比',
    },
    // 克罗地亚语
    hrHR: {
        fill_in_at_least_one_query_condition: 'Unesite barem jedan uvjet pretraživanja',
        full_query: 'Potpuno upit',
        query_time: 'Vrijeme upita',
        organization_code: 'Kôd organizacije',
        organization_name: 'Naziv organizacije',
        country: 'Država',
        number_of_cases: 'Ukupan broj slučajeva',
        waiting_for_reply_cases: 'Broj slučajeva bez odgovora',
        percentage_of_No_Responses: 'Postotak slučajeva bez odgovora',
        replied_cases: 'Broj slučajeva s odgovorom',
        percentage_of_replied_cases: 'Postotak slučajeva s odgovorom',
        closed_cases: 'Broj zatvorenih slučajeva',
        percentage_closed_cases: 'Postotak zatvorenih slučajeva',
    },
    // 拉脱维亚语
    lvLV: {
        fill_in_at_least_one_query_condition:
            'Lūdzu, aizpildiet vismaz vienu meklēšanas nosacījumu',
        full_query: 'Pilns vaicājums',
        query_time: 'Vaicājuma laiks',
        organization_code: 'Organizācijas kods',
        organization_name: 'Organizācijas nosaukums',
        country: 'Valsts',
        number_of_cases: 'Gadījumu kopējais skaits',
        waiting_for_reply_cases: 'Neatbildēto gadījumu skaits',
        percentage_of_No_Responses: 'Neatbildēto gadījumu procents',
        replied_cases: 'Atbildēto gadījumu skaits',
        percentage_of_replied_cases: 'Atbildēto gadījumu procents',
        closed_cases: 'Slēgto gadījumu skaits',
        percentage_closed_cases: 'Slēgto gadījumu procents',
    },
    // 立陶宛语
    ltLT: {
        fill_in_at_least_one_query_condition: 'Įveskite bent vieną paieškos sąlygą',
        full_query: 'Visų duomenų užklausa',
        query_time: 'Užklausos laikas',
        organization_code: 'Organizacijos kodas',
        organization_name: 'Organizacijos pavadinimas',
        country: 'Šalis',
        number_of_cases: 'Atvejų skaičius iš viso',
        waiting_for_reply_cases: 'Laukiamų atsakymo atvejų skaičius',
        percentage_of_No_Responses: 'Laukiamų atsakymo atvejų procentas',
        replied_cases: 'Atsakytų atvejų skaičius',
        percentage_of_replied_cases: 'Atsakytų atvejų procentas',
        closed_cases: 'Uždarytų atvejų skaičius',
        percentage_closed_cases: 'Uždarytų atvejų procentas',
    },
    // 罗马尼亚语
    roRO: {
        fill_in_at_least_one_query_condition: 'Completați cel puțin o condiție de căutare',
        full_query: 'Interogare completă',
        query_time: 'Timpul interogării',
        organization_code: 'Codul organizației',
        organization_name: 'Numele organizației',
        country: 'Țară',
        number_of_cases: 'Număr total de cazuri',
        waiting_for_reply_cases: 'Numărul de cazuri fără răspuns',
        percentage_of_No_Responses: 'Procentul cazurilor fără răspuns',
        replied_cases: 'Numărul de cazuri cu răspuns',
        percentage_of_replied_cases: 'Procentul cazurilor cu răspuns',
        closed_cases: 'Numărul de cazuri închise',
        percentage_closed_cases: 'Procentul cazurilor închise',
    },
    // 挪威博克马尔语
    nbNO: {
        fill_in_at_least_one_query_condition: 'Fyll ut minst ett søkekriterium',
        full_query: 'Full spørring',
        query_time: 'Spørringstidspunkt',
        organization_code: 'Organisasjonskode',
        organization_name: 'Organisasjonsnavn',
        country: 'Land',
        number_of_cases: 'Totalt antall saker',
        waiting_for_reply_cases: 'Antall ubesvarte saker',
        percentage_of_No_Responses: 'Prosentandel ubesvarte saker',
        replied_cases: 'Antall besvarte saker',
        percentage_of_replied_cases: 'Prosentandel besvarte saker',
        closed_cases: 'Antall lukkede saker',
        percentage_closed_cases: 'Prosentandel lukkede saker',
    },
    // 葡萄牙语（巴西）
    ptBX: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        full_query: 'Consulta completa',
        query_time: 'Horário da consulta',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        waiting_for_reply_cases: 'Quantidade de casos sem resposta',
        percentage_of_No_Responses: 'Percentual de casos sem resposta',
        replied_cases: 'Quantidade de casos respondidos',
        percentage_of_replied_cases: 'Percentual de casos respondidos',
        closed_cases: 'Quantidade de casos encerrados',
        percentage_closed_cases: 'Percentual de casos encerrados',
    },
    // 瑞典语
    svSE: {
        fill_in_at_least_one_query_condition: 'Ange minst ett sökvillkor',
        full_query: 'Fullständig förfrågan',
        query_time: 'Förfråganstidpunkt',
        organization_code: 'Organisationskod',
        organization_name: 'Organisationsnamn',
        country: 'Land',
        number_of_cases: 'Totalt antal fall',
        waiting_for_reply_cases: 'Antal obesvarade ärenden',
        percentage_of_No_Responses: 'Andel obesvarade ärenden (%)',
        replied_cases: 'Antal besvarade ärenden',
        percentage_of_replied_cases: 'Andel besvarade ärenden (%)',
        closed_cases: 'Antal avslutade ärenden',
        percentage_closed_cases: 'Andel avslutade ärenden (%)',
    },
    // 斯洛伐克语
    skSK: {
        fill_in_at_least_one_query_condition: 'Zadajte aspoň jednu podmienku vyhľadávania',
        full_query: 'Kompletný dopyt',
        query_time: 'Čas dopytu',
        organization_code: 'Kód organizácie',
        organization_name: 'Názov organizácie',
        country: 'Krajina',
        number_of_cases: 'Celkový počet prípadov',
        waiting_for_reply_cases: 'Počet prípadov bez odpovede',
        percentage_of_No_Responses: 'Percento prípadov bez odpovede',
        replied_cases: 'Počet prípadov s odpoveďou',
        percentage_of_replied_cases: 'Percento prípadov s odpoveďou',
        closed_cases: 'Počet uzavretých prípadov',
        percentage_closed_cases: 'Percento uzavretých prípadov',
    },
    // 斯洛文尼亚语
    slSI: {
        fill_in_at_least_one_query_condition: 'Vnesite vsaj en pogoj za poizvedbo',
        full_query: 'Polna poizvedba',
        query_time: 'Čas poizvedbe',
        organization_code: 'Koda organizacije',
        organization_name: 'Ime organizacije',
        country: 'Država',
        number_of_cases: 'Skupno število primerov',
        waiting_for_reply_cases: 'Število primerov brez odgovora',
        percentage_of_No_Responses: 'Odstotek primerov brez odgovora',
        replied_cases: 'Število primerov z odgovorom',
        percentage_of_replied_cases: 'Odstotek primerov z odgovorom',
        closed_cases: 'Število zaključenih primerov',
        percentage_closed_cases: 'Odstotek zaključenih primerov',
    },
    // 泰语
    thTH: {
        fill_in_at_least_one_query_condition: 'กรุณากรอกเงื่อนไขการค้นหาอย่างน้อยหนึ่งรายการ',
        full_query: 'สอบถามข้อมูลทั้งหมด',
        query_time: 'เวลาการสอบถาม',
        organization_code: 'รหัสองค์กร',
        organization_name: 'ชื่อองค์กร',
        country: 'ประเทศ',
        number_of_cases: 'จำนวนกรณีทั้งหมด',
        waiting_for_reply_cases: 'จำนวนกรณีที่ยังไม่ได้รับการตอบกลับ',
        percentage_of_No_Responses: 'เปอร์เซ็นต์ของกรณีที่ยังไม่ได้รับการตอบกลับ',
        replied_cases: 'จำนวนกรณีที่ได้รับการตอบกลับแล้ว',
        percentage_of_replied_cases: 'เปอร์เซ็นต์ของกรณีที่ได้รับการตอบกลับแล้ว',
        closed_cases: 'จำนวนกรณีที่ปิดแล้ว',
        percentage_closed_cases: 'เปอร์เซ็นต์ของกรณีที่ปิดแล้ว',
    },
    // 乌克兰语
    ukUA: {
        fill_in_at_least_one_query_condition: 'Будь ласка, введіть принаймні одну умову пошуку',
        full_query: 'Повний запит',
        query_time: 'Час запиту',
        organization_code: 'Код організації',
        organization_name: 'Назва організації',
        country: 'Країна',
        number_of_cases: 'Загальна кількість випадків',
        waiting_for_reply_cases: 'Кількість випадків без відповіді',
        percentage_of_No_Responses: 'Відсоток випадків без відповіді',
        replied_cases: 'Кількість випадків з відповіддю',
        percentage_of_replied_cases: 'Відсоток випадків з відповіддю',
        closed_cases: 'Кількість закритих випадків',
        percentage_closed_cases: 'Відсоток закритих випадків',
    },
    // 希腊语
    elGR: {
        fill_in_at_least_one_query_condition: 'Συμπληρώστε τουλάχιστον ένα κριτήριο αναζήτησης',
        full_query: 'Πλήρης ερώτημα',
        query_time: 'Χρόνος ερωτήματος',
        organization_code: 'Κωδικός οργανισμού',
        organization_name: 'Όνομα οργανισμού',
        country: 'Χώρα',
        number_of_cases: 'Συνολικός αριθμός περιστατικών',
        waiting_for_reply_cases: 'Αριθμός περιστατικών χωρίς απάντηση',
        percentage_of_No_Responses: 'Ποσοστό περιστατικών χωρίς απάντηση',
        replied_cases: 'Αριθμός περιστατικών με απάντηση',
        percentage_of_replied_cases: 'Ποσοστό περιστατικών με απάντηση',
        closed_cases: 'Αριθμός κλεισμένων περιστατικών',
        percentage_closed_cases: 'Ποσοστό κλεισμένων περιστατικών',
    },
    // 爱沙尼亚语
    etEE: {
        fill_in_at_least_one_query_condition: 'Sisestage vähemalt üks otsingu tingimus',
        full_query: 'Täielik päring',
        query_time: 'Päringu aeg',
        organization_code: 'Organisatsiooni kood',
        organization_name: 'Organisatsiooni nimi',
        country: 'Riik',
        number_of_cases: 'Juhtumite koguarv',
        waiting_for_reply_cases: 'Vastamata juhtumite arv',
        percentage_of_No_Responses: 'Vastamata juhtumite protsent',
        replied_cases: 'Vastatud juhtumite arv',
        percentage_of_replied_cases: 'Vastatud juhtumite protsent',
        closed_cases: 'Suletud juhtumite arv',
        percentage_closed_cases: 'Suletud juhtumite protsent',
    },
    // 哈萨克语
    kkKZ: {
        fill_in_at_least_one_query_condition: 'Кем дегенде бір сұрау шартын енгізіңіз',
        full_query: 'Толық сұрау',
        query_time: 'Сұрау уақыты',
        organization_code: 'Ұйым коды',
        organization_name: 'Ұйым атауы',
        country: 'Ел',
        number_of_cases: 'Жағдайлардың жалпы саны',
        waiting_for_reply_cases: 'Жауап берілмеген жағдайлар саны',
        percentage_of_No_Responses: 'Жауап берілмеген жағдайлар пайызы',
        replied_cases: 'Жауап берілген жағдайлар саны',
        percentage_of_replied_cases: 'Жауап берілген жағдайлар пайызы',
        closed_cases: 'Жабылған жағдайлар саны',
        percentage_closed_cases: 'Жабылған жағдайлар пайызы',
    },
    // 希伯来语
    heIL: {
        fill_in_at_least_one_query_condition: 'יש למלא לפחות תנאי חיפוש אחד',
        full_query: 'שאילתה מלאה',
        query_time: 'זמן השאילתה',
        organization_code: 'קוד ארגון',
        organization_name: 'שם הארגון',
        country: 'מדינה',
        number_of_cases: 'סך כל המקרים',
        waiting_for_reply_cases: 'כמות מקרים ללא תגובה',
        percentage_of_No_Responses: 'אחוז מקרים ללא תגובה',
        replied_cases: 'כמות מקרים עם תגובה',
        percentage_of_replied_cases: 'אחוז מקרים עם תגובה',
        closed_cases: 'כמות מקרים שנסגרו',
        percentage_closed_cases: 'אחוז מקרים שנסגרו',
    },
};
